import React, { useEffect, useState } from 'react';
import actions from '../reducers/actions';
import { connect } from 'react-redux';
import { Toast } from 'devextreme-react';
import Navigation from '../components/Navigation';
import ViewTable from '../components/table/ViewTable';
import columns from '../definiftions/vendorReportColumns';
import { getVendorReport } from '../service/client';

function VendorReport(props) {
  const { user, logout, endImpersonation, setOverrideUrl } = props

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setLoading(true);
    getVendorReport(user).then(r => {
      setRows(r.body);
    })
      .catch(() => {
        setVisible(true);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  return (
    <>
      <Navigation logout={() => logout(user)} user={user} endImpersonation={endImpersonation} setOverrideUrl={setOverrideUrl} />
      <ViewTable {...{
        columns,
        loading,
        rows,
      }} />
      <Toast {...{
        visible,
        message: 'There was an error loading the report.',
        type: 'error',
        onHiding: () => setVisible(false),
        displayTime: 4000,
      }} />
    </>
  )
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(VendorReport)